import type { TFunction } from 'i18next';
import type { ItemDefinition } from '@admin/pages/personalization/content-block-slides.ts';

/** Valeurs stockées dans `filter_image` (0–100, overlay sombre sur l’image). */
export const FILTER_PRESETS = [
  {
    value: '0',
    labelKey: 'admin.contentblock.editor.filter.none',
    subtitleKey: 'admin.contentblock.editor.filter.none.hint',
    recommended: true
  },
  {
    value: '20',
    labelKey: 'admin.contentblock.editor.filter.p20',
    subtitleKey: 'admin.contentblock.editor.filter.p20.hint',
    recommended: false
  },
  {
    value: '40',
    labelKey: 'admin.contentblock.editor.filter.p40',
    subtitleKey: 'admin.contentblock.editor.filter.p40.hint',
    recommended: false
  },
  {
    value: '60',
    labelKey: 'admin.contentblock.editor.filter.p60',
    subtitleKey: 'admin.contentblock.editor.filter.p60.hint',
    recommended: false
  }
] as const;

export const resolveFilterPresetValue = (raw: unknown): string => String(raw ?? '0');

export const slideFormInputClassName =
  'h-11 rounded-xl border-border/70 bg-muted/25 shadow-none focus-visible:ring-primary/30';

export const hslCoreToPickerValue = (core: string): string => {
  const trimmed = core.trim();
  if (trimmed.startsWith('hsl')) {
    return trimmed;
  }
  const parts = trimmed.split(/\s+/);
  if (parts.length >= 3) {
    return `hsl(${parts[0]}, ${parts[1]}, ${parts[2]})`;
  }
  return `hsl(${trimmed})`;
};

const toComparableHslCore = (value: string): string => {
  let normalized = value.trim().toLowerCase();
  const hslMatch = /^hsla?\((.+)\)$/.exec(normalized);
  if (hslMatch?.[1]) {
    normalized = hslMatch[1];
  }
  return normalized.replace(/,/g, ' ').replace(/\s+/g, ' ').trim();
};

export const colorsMatchHsl = (left: string, right: string): boolean =>
  toComparableHslCore(left) === toComparableHslCore(right);

export type TextColorPreset = {
  id: 'white' | 'black';
  value: string;
  label: string;
  cssBackground: string;
};

export interface ContentBlockSlideFieldControlProps {
  itemDefinition: ItemDefinition;
  value: unknown;
  onChange: (value: unknown) => void;
  t: TFunction;
  textColorPresets: TextColorPreset[];
  progresses: Record<string, number> | undefined;
  mediaFieldDisabled: boolean;
  onMediaUpload: (
    itemKey: string,
    files: File[],
    onChange: (value: string) => void
  ) => void | Promise<void>;
}
